// Types
import type { ApplicationProps } from '@/types/config'

const Config: ApplicationProps = {
	name: process.env.APP_NAME || 'rateup',
	shortName: process.env.APP_SHORT_NAME || 'rateup-application',
	siteUrl: process.env.SITE_URL || 'https://app.rateup.ir',
	timezone: process.env.APP_TIMEZONE || 'Asia/Tehran'
}

export default Config
